<template>
  <div class="notificationComp">
    <div class="notificationComp__head">
          <h1 class="mobiTitle md">{{ $t("notification") }}</h1>
    </div>
    <ul>
      <li  v-for="item in notification_gonz" :key="item.key">
        <router-link :to="{name: 'DetailPage',params: { id: item.id }}" class="notificationComp__wrap" >
          <div class="notificationComp__img">
              <img :src="item.thumbnail_url"/>
          </div>
          <div class="notificationComp__content">
            <!-- <h2 class="mobiTitle sm">{{item.cont_name_english}}</h2> -->
            <span v-if="lang_gonz !== 'english'">
              <h2 class="mobiTitle sm" v-if="item[`cont_name_${lang_gonz}`] !== ''">{{ item[`cont_name_${lang_gonz}`] }}</h2>
              <h2 class="mobiTitle sm" v-else>{{ item[`cont_name_english`] }}</h2>
            </span>
            <span v-else>
              <h2 class="mobiTitle sm">{{ item[`cont_name_english`] }}</h2>
            </span>
            <p class="mobilabel">{{ item[`titleSub_${lang_gonz}`] }}</p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["notification_gonz", "lang_gonz", "country_gonz"])
  },
  created() {
    this.fetchNotification_gonz();
  },
  methods: {
    ...mapActions(["fetchNotification_gonz"])
  }
};
</script>

<style scoped lang="scss">
.notificationComp {
  background: #fdad02;
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  ul {
    list-style: none;
    padding: 0;
  }

  a {
    display: flex;
    color: #000;
    text-decoration: none;
    padding: 15px;
  }
  img {
    width: 100%;
  }
  .notificationComp__head .mobiTitle,
  .notificationComp__content .mobiTitle {
    color: #151515;
  }
  .notificationComp__content .mobilabel {
    color: #9a6900;
  }
}
.notificationComp__head {
  padding: 8px 15px;
}
.notificationComp__content {
  padding-left: 8px;
}
.notificationComp__img {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
}
.ar_layout {
  .notificationComp__content {
    padding-left: 0;
    padding-right: 8px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gameonz/Notification.vue